/**
 * ErrorBoundary para capturar errores de React
 */

import React, { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div role="alert" className="error-boundary">
          <h2>Algo salió mal</h2>
          <p>{this.state.error?.message || 'Ha ocurrido un error inesperado'}</p>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            type="button"
          >
            Reintentar
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

